// rc-upload 2.9.4
import upload from './src';

export default upload;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-upload/index.js
// module id = 912
// module chunks = 0